"use client"

import * as React from "react"

import { cn } from "../../lib/utils"
import { Button } from "./button"

export interface AppealWindowCardProps {
  className?: string
  timeRemaining: string
  onAppeal?: () => void
  isLoading?: boolean
  disabled?: boolean
}

function AppealWindowCard({
  className,
  timeRemaining,
  onAppeal,
  isLoading = false,
  disabled = false,
}: AppealWindowCardProps) {
  return (
    <div
      className={cn(
        "bg-white border border-black rounded-lg overflow-hidden shadow-[0px_4px_0px_0px_#000000]",
        className
      )}
    >
      {/* Title */}
      <div className="px-4 py-3">
        <h3 className="text-sm font-semibold text-[#344054]">Appeal Window</h3>
      </div>

      {/* Timer Row */}
      <div className="flex items-center justify-between px-4 py-3 border-t border-gray-100">
        <span className="text-sm text-[#667085]">Appeal within:</span>
        <span className="text-sm font-semibold text-[#344054]">{timeRemaining}</span>
      </div>

      {/* Info Text */}
      <div className="px-4 pb-3">
        <p className="text-xs text-[#667085] text-center">
          After the window ends, you&apos;ll be able to reapply in the next review cycle.
        </p>
      </div>

      {/* Appeal Button */}
      <div className="px-4 pb-4">
        <Button
          className="w-full"
          onClick={onAppeal}
          disabled={isLoading || disabled}
        >
          {isLoading ? "Submitting..." : "Appeal Review"}
        </Button>
      </div>
    </div>
  )
}

export { AppealWindowCard }
